
/**
 * Form Configuration
 * 
 * Email form handler endpoint configuration
 * 
 * For local development with Node.js server:
 *   NODE_FORM_URL: 'http://localhost:3001/api/contact'
 * 
 * For production:
 *   NODE_FORM_URL: 'https://your-domain.com/api/contact'
 * 
 * reCAPTCHA Configuration:
 *   Get your keys from: https://www.google.com/recaptcha/admin
 *   RECAPTCHA_SITE_KEY: Your reCAPTCHA v3 Site Key (public, safe to expose)
 */

export const FORM_CONFIG = {
  // Node.js Form Handler Endpoint
  // Same-origin path in builds: the site's nginx forwards /api/ to the backend,
  // so one build works on TEST and production. Local dev talks to the server directly.
  NODE_FORM_URL: import.meta.env.DEV
    ? 'http://localhost:3001/api/contact'
    : '/api/contact',
  
  // reCAPTCHA v3 Site Key (public key - safe to expose in frontend)
  // Get your keys from: https://www.google.com/recaptcha/admin
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LfuoyYsAAAAADhTRGBIqUFQj68zY_ystG4f8jAb',
};

